import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

interface MarkInvoicePaidPayload {
  company_id: string;
  invoice_id: string;
}

interface MarkInvoicePaidResponse {
  invoice_id: string;
  status: string;
}

async function markInvoicePaidOutOfBand(
  payload: MarkInvoicePaidPayload,
  auth: Authentication
): Promise<MarkInvoicePaidResponse> {
  try {
    const response = await HttpClient.post(
      '/leedflow/stripe/backoffice/invoice-paid-out-of-band',
      payload,
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('markInvoicePaidOutOfBand error:', e);
    throw new MarkInvoicePaidOutOfBandFailure(e.message);
  }
}

export class MarkInvoicePaidOutOfBandFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default markInvoicePaidOutOfBand;
